// @flow
import type {GraphQLTaggedNode} from 'react-relay'
import {graphql} from 'react-relay'

import type {Strategy} from 'components/proposals/types'
import Editor from './Editor'
import Summary from './Summary'
import createPartComponent from '../createPartComponent'
import fetchFieldsFromChange from './fetchFieldsFromChange'
import changePayload from './changePayload'
import type {Change, State} from './types'

/* eslint class-methods-use-this: 0 */

const query = {
  organization: graphql`
    fragment LinkedRole_organization on Organization {
      databaseId
      domainsLabel: termFor(name: "domains")
      purposeLabel: termFor(name: "purpose")

      ...Accountabilities_organization
      ...WYSIWYGTextareaWithFeatureFlag_organization
  }`,
  subscriptionChange: graphql`
    fragment LinkedRoleSubscription_change on DescribeChangeable {
      command

      alerts {
        path
        message
        severity
      }

      ... on LinkedRoleChange {
        circle {
          databaseId
          localizedName

          ...Accountabilities_circle
        }
        
        originalRole {
          databaseId
          localizedName
          purpose
        }
        
        linkedRole {
          databaseId
          localizedName

          accountabilities(first: 100) {
            edges {
              node {
                databaseId
                description
                isProtected
              }
            }
          }

          domains(first: 100) {
            edges {
              node {
                databaseId
                description
                isProtected
              }
            }
          }
          
          originalRole {
            databaseId
            localizedName
            purpose

            circle {
              localizedName
            }

            accountabilities(first: 100) {
              edges {
                node {
                  databaseId
                  description
                  isProtected
                }
              }
            }

            domains(first: 100) {
              edges {
                node {
                  databaseId
                  description
                  isProtected
                }
              }
            }
          }
        }
      }
    }
  `,
  change: graphql`
    fragment LinkedRole_change on DescribeChangeable {
      id
      databaseId
      type

      ... on LinkedRoleChange {
        availableRoles(first: 100) {
          edges {
            node {
              databaseId
              localizedName

              circle {
                localizedName
              }
            }
          }
        }
      }

      ...SummarySections_change
      ...LinkedRoleSubscription_change @relay(mask: false)
    }
  `,
}

class LinkedRoleStrategy implements Strategy {
  static displayName = 'LinkedRole'
  static fieldsFromChange = fetchFieldsFromChange
  static query: {[string]: GraphQLTaggedNode, ...} = query

  change: Change
  changeKey: string

  constructor(change: Change) {
    this.change = change
    this.changeKey = `Part-LinkedRole-${change.databaseId || 'new'}`
  }

  get partDescription(): string {
    return this.change.linkedRole?.localizedName || ''
  }

  get className(): string {
    return ''
  }

  get partTitle(): string {
    return this.change.type === 'CreateLinkedRole'
      ? I18n.t('proposals.link_role.link_invitataion')
      : I18n.t('proposals.link_role.edit_role_link')
  }

  changePayload(state: State): Object {
    return changePayload(this.change, state)
  }
}

export default (createPartComponent(LinkedRoleStrategy, Editor, Summary): any)
